module.exports = __webpack_public_path__ + "img/btn.1e1757ed.svg";